import axios from "axios";
import { useQuery } from "@tanstack/react-query";
import { API_BACKEND_URL } from "../Config/Config";

const getUserDetails = () => {
  const userDetails = localStorage.getItem("userDetail");
  if (!userDetails) throw new Error("No user details found in localStorage");
  return JSON.parse(userDetails);
};

const getDashboardData = async ({ dateFrom, dateTo, method } = {}) => {
  const user = getUserDetails();
  const params = new URLSearchParams({ companyid: user.companyid });
  if (dateFrom) params.append("dateFrom", dateFrom);
  if (dateTo) params.append("dateTo", dateTo);
  if (method) params.append("method", method);
  const response = await axios.get(`${API_BACKEND_URL}/dashboarddata?${params.toString()}`);
  return response.data;
};

export const useGetDashboardData = (filters = {}, options = {}) => {
  return useQuery({
    queryKey: ["apiDashboardData", filters],
    queryFn: () => getDashboardData(filters),
    ...options,
  });
};
